import moment from "moment";

export const isTomorrowDate = date => {
    return date?.length > 1 && moment().diff(date[0], "days") === 1 && moment().diff(date[1], "days") === 1;
};
